<template>
  <div class="nx-select">
    <slot name="default" :data="data" :show-value="showValue" />
    <div class="nx-select_trigger" @click="showPicker = true">
      <slot v-if="$scopedSlots.trigger" name="trigger" :title="title" />
      <van-field
        v-else
        v-bind="$attrs"
        readonly
        clickable
        :value="showValue"
        right-icon="arrow"
        :label="title"
        :placeholder="placeholder"
        input-align="right"
      />
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="handleConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
/**
 * select选择器，支持插槽，示例：src/views/maintenance/appointment/index.vue
 */
export default {
  name: 'NxSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, undefined],
      required: true,
    },
    placeholder: {
      type: String,
      default: '点击选择',
    },
    labelKey: {
      type: String,
      default: 'label',
    },
    valueKey: {
      type: String,
      default: 'value',
    },
  },
  data() {
    return {
      showPicker: false,
      data: {},
    };
  },
  computed: {
    value_: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
    showValue() {
      return this.options.find(v => v[this.valueKey] === this.value_)?.[this.labelKey] || '';
    },
    columns() {
      return this.options.map(v => v[this.labelKey]);
    },
  },
  watch: {
    value_(newVal) {
      if (newVal) {
        const item = this.options.find(v => v[this.valueKey] === newVal);
        this.$emit('change', item);
      }
      else {
        this.$emit('change', undefined);
      }
    },
  },
  methods: {
    handleConfirm(label, index) {
      const item = this.options[index];
      this.data = item;
      this.value_ = item[this.valueKey];
      this.showPicker = false;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
